import { render, staticRenderFns } from "./FooterCard.component.vue?vue&type=template&id=ed1413b2"
import script from "./FooterCard.component.vue?vue&type=script&lang=js"
export * from "./FooterCard.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports